module.exports = __webpack_public_path__ + "img/LAL_login_btn_Story.2daaa017.svg";